export default {
    400: {
        title: "Mauvaise demande",
        header: "@:views.errors.400.title",
        html: "Requête incorrecte. Veuillez réessayer plus tard."
    },
    401: {
        title: "Une erreur s'est produite lors de la connexion.",
        header: "@:views.errors.401.title",
        html: "Veuillez contacter <a href='{email}' target='_blank'>le support</a> ."
    },
    404: {
        title: "Page introuvable",
        header: "@:views.errors.404.title"
    },
    403: {
        title: "Accès non autorisé",
        header: "Accès non autorisé",

        contact: "O-I Ce service est réservé aux employés. Si vous êtes employé et que vous voyez ce message, veuillez contacter votre service des ressources humaines local pour mettre à jour votre statut.",

        subject: "Équipement - Admissibilité",

        html: "<p class='text-start'>@:views.errors.403.eligibility @:views.errors.403.contact</p>",
        error: {
            disabled: {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Vous n'êtes actuellement pas admissible. Veuillez contacter <a href='#' role='button' data-widget-trigger='{widgetOptions}'>le support</a> pour plus d'informations.</p>"
            },
            "not-active": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Vous n'êtes actuellement pas admissible. Veuillez contacter votre service des ressources humaines local pour plus d'informations.</p>"
            },
            "not-allowed":{
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>O-I Ce service est réservé aux employés. Si vous êtes employé et que vous voyez ce message, veuillez contacter votre service des ressources humaines local pour mettre à jour votre statut.</p>"
            },
            "no-manager": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Aucun responsable n'est actuellement indiqué dans votre profil ServiceNow. Veuillez contacter votre représentant local des Ressources Humaines pour mettre à jour les informations concernant votre responsable.</p>"
            },
            "self-manager": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Votre responsable est actuellement défini comme étant vous dans votre profil ServiceNow. Veuillez contacter votre représentant local des Ressources Humaines pour mettre à jour les informations concernant votre responsable.</p>"
            },
            "no-location": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Aucune localisation n'est indiquée dans votre profil ServiceNow. Veuillez contacter votre représentant local des Ressources humaines pour la mettre à jour.</p>"
            },
            eligibility: {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>O-I Ce service est réservé aux employés. Si vous êtes employé et que vous voyez ce message, veuillez contacter votre service des ressources humaines pour mettre à jour votre statut.</p>",
            },
            "eligibility-location": {
                header: "",
                html: "Merci de votre intérêt pour O-I Périphérique. Ce programme n'est actuellement pas disponible dans votre pays.",
            },
            "secondary-account": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Vous tentez actuellement d'accéder à O-I Périphérique avec un compte secondaire. Veuillez réessayer de vous connecter avec votre compte principal.</p>"
            },
            "empty-core-id": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Votre compte ServiceNow ne comporte pas de nom. Veuillez contacter votre responsable des ressources humaines local pour le mettre à jour.</p>"
            },
            country: {
                header: "@:views.errors.403.header",
                html: " @:views.errors.403.eligibility @:views.errors.403.contact",
            },
            "no-permissions": {
                header: "Aucun accès",
                subject: "Aucun accès",
                html: "Vous n'êtes pas autorisé à ouvrir cette page.",
            },
            "virtual-denied": {
                header: "On dirait que tu es un peu en avance...",
                html: "<p class='text-start'>Merci de votre intérêt pour O-I Peripheral. Il semble que vous ayez accédé au site avant d'avoir reçu votre invitation. O-I Peripheral est déployé progressivement, pays par pays et par groupes d'utilisateurs. Une fois votre compte activé, vous recevrez un e-mail contenant une invitation personnelle et les instructions.</p><p class='text-start'> Cliquez sur <a href='#' role='button' data-widget-trigger='{widgetOptions}'>Assistance</a> pour toute question ou problème concernant votre commande ou le site.</p>",
            }
        }
    },
    500: {
        title: "Erreur inattendue",
        header: "@:views.errors.500.title",
        message: "Une erreur s'est produite. Veuillez réessayer plus tard."
    },
    code: {
        title: "Erreur inattendue",
        message: "@:views.errors.code.title",
        error: "Erreur {code}."
    }
}